import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useHermes } from "./HermesProvider";
import { HermesSkillsPanel } from "./HermesSkillsPanel";

/** Hermes header：技能管理入口（DB Skills，非 toolset chips）。 */
export function HermesSkillsMenu() {
  const { accountId } = useHermes();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 gap-1 px-2 text-xs font-medium"
        aria-label="技能与工具"
        disabled={!accountId}
        onClick={() => setOpen(true)}
      >
        <Sparkles className="size-3.5" />
        技能
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex h-[min(90vh,40rem)] w-[min(calc(100%-2rem),56rem)] max-w-none flex-col gap-0 overflow-hidden p-0 sm:max-w-none">
          <DialogHeader className="sr-only">
            <DialogTitle>技能与工具</DialogTitle>
            <DialogDescription>管理 Hermes 技能包、查看系统技能与后续工具扩展</DialogDescription>
          </DialogHeader>
          {accountId ? <HermesSkillsPanel accountId={accountId} /> : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
